import { createImpossibleFieldErrorMessage, createMissingFieldErrorMessage, createYoungerThan17ErrorMessage, } from './dateOfBirthValidator.utils';
export var InputValidationError;
(function (InputValidationError) {
    InputValidationError["RealDateError"] = "realDateError";
    InputValidationError["DateBefore1900Error"] = "dateBefore1900Error";
    InputValidationError["YoungerThan17"] = "youngerThan17";
})(InputValidationError || (InputValidationError = {}));
export var FieldValidationError;
(function (FieldValidationError) {
    FieldValidationError["MissingFieldError"] = "missingFieldError";
    FieldValidationError["InvalidInputValueError"] = "invalidInputValueError";
    FieldValidationError["ImpossibleFieldValueError"] = "impossibleFieldValueError";
})(FieldValidationError || (FieldValidationError = {}));
export const dateOfBirthErrorMessages = {
    [InputValidationError.RealDateError]: () => 'Please enter a valid date of birth',
    [InputValidationError.DateBefore1900Error]: () => 'Please enter a date of birth after 1900',
    [FieldValidationError.MissingFieldError]: createMissingFieldErrorMessage,
    [FieldValidationError.InvalidInputValueError]: () => 'Please enter a numeric value',
    [FieldValidationError.ImpossibleFieldValueError]: createImpossibleFieldErrorMessage,
    [InputValidationError.YoungerThan17]: createYoungerThan17ErrorMessage,
};
//# sourceMappingURL=schema.js.map